import React, {useState, useEffect} from 'react';
import {withTranslation} from "react-i18next";
import {Alert, Card, CardBody, Col, Container, Row} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import paginationFactory, {PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import Select from "react-select";
import {formatBytes} from "../../common/general";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import SmallAvatar from "../../components/Common/SmallAvatar";
import {useSelector, useDispatch} from "react-redux";
import {simpleFilesFilter, simpleFilesSegments, simpleFilesList, simpleFilesDownload} from "../../store/simpleFiles/actions";


const SimpleFiles = (props) => {
  const [selectedSection, setSelectedSection] = useState(null)
  const [selectedYear, setSelectedYear] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(null)
  const [selectedSegment, setSelectedSegment] = useState(parseInt(localStorage.getItem("simpleFilesSegment")))
  const [sizePerPage, setSizePerPage] = useState(10)
  const [dataSize, setDataSize] = useState(0)

  const {sections, years, months, loadingFilter, errorFilter, segments, loadingSegments, errorSegments, files, loadingList, errorList} = useSelector(({SimpleFiles}) => ({
    sections: SimpleFiles.sections,
    years: SimpleFiles.years,
    months: SimpleFiles.months,
    loadingFilter: SimpleFiles.loadingFilter,
    errorFilter: SimpleFiles.errorFilter,
    segments: SimpleFiles.segments,
    loadingSegments: SimpleFiles.loadingSegments,
    errorSegments: SimpleFiles.errorSegments,
    files: SimpleFiles.files,
    loadingList: SimpleFiles.loadingList,
    errorList: SimpleFiles.errorList,
  }))

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(simpleFilesFilter({history: props.history}))
  }, [dispatch])

  useEffect(() => {
    if (sections.length > 0) {
      const filesSection = JSON.parse(localStorage.getItem("simpleFilesSection"))
      if (filesSection && sections.some(s => s.value === filesSection.value)) {
        onSelectSection(filesSection)
      } else {
        onSelectSection(sections[0])
      }
      const filesYear = JSON.parse(localStorage.getItem("simpleFilesYear"))
      if (filesYear && years.some(y => y.value === filesYear.value)) {
        onSelectYear(filesYear)
      } else {
        const actualYear = (new Date().getFullYear()).toString()
        const year = years.find(y => y.label === actualYear)
        onSelectYear(year)
      }
      const filesMonth = JSON.parse(localStorage.getItem("simpleFilesMonth"))
      if (filesMonth && months.some(m => m.value === filesMonth.value)) {
        onSelectMonth(filesMonth)
      } else {
        const actualMonth = (new Date().getMonth() + 1).toString()
        const month = months.find(m => m.value === actualMonth)
        onSelectMonth(month)
      }
    }
  }, [sections])

  useEffect(() => {
    if (selectedSection && selectedYear && selectedMonth) {
      loadSegments(selectedSection.value, selectedYear.value, selectedMonth.value)
    }
  }, [selectedSection, selectedYear, selectedMonth])

  const onSelectSection = selectedSection => {
    localStorage.setItem("simpleFilesSection", JSON.stringify(selectedSection))
    setSelectedSection(selectedSection)
  }

  const onSelectYear = selectedYear => {
    localStorage.setItem("simpleFilesYear", JSON.stringify(selectedYear))
    setSelectedYear(selectedYear)
  }

  const onSelectMonth = selectedMonth => {
    localStorage.setItem("simpleFilesMonth", JSON.stringify(selectedMonth))
    setSelectedMonth(selectedMonth)
  }

  const loadSegments = (sectionId, yearId, monthId) => {
    if (sectionId && yearId && monthId) {
      dispatch(simpleFilesSegments({data: {sectionId: sectionId, yearId: yearId, monthId: monthId}, history: props.history}))
      if (selectedSegment) {
        loadFiles(sectionId, yearId, monthId, selectedSegment.toString())
      }
    }
  }

  const onSelectSegment = segmentId => {
    localStorage.setItem("simpleFilesSegment", segmentId)
    loadFiles(selectedSection.value, selectedYear.value, selectedMonth.value, segmentId.toString())
    setSelectedSegment(segmentId)
  }

  const loadFiles = (sectionId, yearId, monthId, segmentId) => {
    if (sectionId && yearId && monthId && segmentId) {
      dispatch(simpleFilesList({data: {sectionId: sectionId, yearId: yearId, monthId: monthId, segmentId: segmentId}, history: props.history}))
    }
  }

  const onSizePerPageChange = sizePerPage => {
    setSizePerPage(sizePerPage)
  }

  const onDataSizeChange = ({dataSize}) => {
    setDataSize(dataSize)
  }

  document.title = "Files | FileJet";

  const uploaderFormatter = (cell, row) => {
    return (<div>
      <SmallAvatar user={row.uploader} history={props.history}/>
    </div>);
  }

  const downloadFormatter = (cell, row) => {
    return (<div>
      <a className="bx bx-download font-size-20" title="Download" onClick={() => (dispatch(simpleFilesDownload({sign: row.sign, filename: row.name, history: props.history})))}></a>
    </div>);
  }

  const onColumnMatch = ({searchText, value, column, row}) => {
    if (row.name.toLowerCase().includes(searchText) || row.created.toLowerCase().includes(searchText)) return true
    return false
  }

  const columns = [{
    dataField: "name", text: "Name", sort: true, editable: false,
  }, {
    dataField: "uploader", text: "Uploader", sort: true, editable: false, formatter: uploaderFormatter,
  }, {
    dataField: "created", text: "Created", sort: true, editable: false,
  }, {
    dataField: "", text: "Download", editable: false, formatter: downloadFormatter,
  },];

  const defaultSorted = [{
    dataField: "id", order: "asc",
  },];

  const pageOptions = {
    sizePerPage: sizePerPage, totalSize: dataSize, custom: true, onSizePerPageChange: onSizePerPageChange, sizePerPageList: [{
      text: '10', value: 10
    }, {
      text: '25', value: 25
    }, {
      text: '50', value: 50
    }]
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("FileJet")} breadcrumbItem={props.t("Files")}/>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={files}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={files}
                      search={{
                        onColumnMatch,
                      }}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col className="col-4">
                            Section
                            <Select options={sections} value={selectedSection} onChange={onSelectSection}/>
                          </Col>
                          <Col className="col-2">
                            Year
                            <Select options={years} value={selectedYear} onChange={onSelectYear}/>
                          </Col>
                          <Col className="col-2">
                            Month
                            <Select options={months} value={selectedMonth} onChange={onSelectMonth}/>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <Search.SearchBar {...toolkitProps.searchProps} placeholder="Filter" delay={0}/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          {segments.map(segment => {
                            const segmentClass = selectedSegment === segment.id ? "shadow-none border bg-opacity-25 bg-info" : "shadow-none border"
                            return (<Col key={segment.id} md={2}>
                              <Card className={segmentClass} role="button" onClick={() => {
                                onSelectSegment(segment.id)
                              }}>
                                <CardBody className="p-3">
                                  <div>
                                    <div className="avatar-xs me-3 mb-3">
                                      <div className="avatar-title bg-transparent rounded">
                                        <i className="bx bxs-folder font-size-24 text-warning"></i>
                                      </div>
                                    </div>
                                    <div>
                                      <div className="overflow-hidden me-auto">
                                        <h5 className="font-size-14 text-truncate mb-1">{segment.name}</h5>
                                      </div>
                                      <div className="d-flex">
                                        <div className="col-6"><p className="text-muted mb-0">{segment.count} Files</p></div>
                                        <div className="col-6" style={{"fontSize": ".7rem"}}><p className="text-muted mb-0 float-end">{formatBytes(segment.size)}</p></div>
                                      </div>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>)
                          })}
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                onDataSizeChange={onDataSizeChange}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {(loadingList || loadingFilter || loadingSegments) && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {errorFilter.length > 0 && (<div className="mt-3"><Alert color="danger" role="alert">{errorFilter}</Alert></div>)}
                  {errorSegments.length > 0 && (<div className="mt-3"><Alert color="danger" role="alert">{errorSegments}</Alert></div>)}
                  {errorList.length > 0 && (<div className="mt-3"><Alert color="danger" role="alert">{errorList}</Alert></div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(SimpleFiles);
